// File: components/CountryFormDetails.js
import React from "react"
import { Col } from "reactstrap"
import { Field } from "lib/formik"
import TextError from "components/Shared/TextError"

const COUNTRY_CODE_MAX_LENGTH = 3
const DIAL_CODE_MAX_LENGTH = 5 // e.g. +966

const sanitizeCountryCode = value =>
  String(value || "")
    .replace(/[^A-Za-z]/g, "")
    .toUpperCase()
    .slice(0, COUNTRY_CODE_MAX_LENGTH)

const sanitizeDialCode = value => {
  const raw = String(value || "")
  const digits = raw.replace(/\D/g, "").slice(0, 4)
  if (!raw) return ""
  // Keep leading "+" once user starts typing; digits-only after it.
  if (raw.startsWith("+") || digits.length > 0) {
    return `+${digits}`.slice(0, DIAL_CODE_MAX_LENGTH)
  }
  return ""
}

const sanitizeDisplayOrder = value => String(value || "").replace(/\D/g, "")

const CountryFormDetails = ({
  touched,
  errors,
  t,
  setFieldValue,
  submitCount = 0,
}) => {
  const fields = [
    {
      name: "name",
      label: t("Name(English)"),
    },
    {
      name: "nameAr",
      label: t("Name(عربي)"),
      rtl: true,
    },
    {
      name: "countryCode",
      label: t("Country Code"),
      maxLength: COUNTRY_CODE_MAX_LENGTH,
      sanitize: sanitizeCountryCode,
    },
    {
      name: "dialCode",
      label: t("Dial Code"),
      maxLength: DIAL_CODE_MAX_LENGTH,
      sanitize: sanitizeDialCode,
      inputMode: "tel",
    },
    {
      name: "phoneNumberLength",
      label: t("Phone Number Length"),
      sanitize: sanitizeDisplayOrder,
      inputMode: "numeric",
    },
    {
      name: "displayOrder",
      label: t("Display Order"),
      sanitize: sanitizeDisplayOrder,
      inputMode: "numeric",
    },
    { name: "currency", label: t("Currency Code") },
    { name: "currencySymbol", label: t("Currency Symbol") },
  ]

  return fields.map(field => {
    const showInvalid =
      Boolean(errors[field.name]) &&
      (Boolean(touched[field.name]) || submitCount > 0)

    return (
      <Col lg={6} key={field.name}>
        <div className="form_field">
          <label htmlFor={field.name}>
            <span className="text-danger">*</span> {field.label}
          </label>
          <Field
            type="text"
            id={field.name}
            name={field.name}
            placeholder={field.label}
            maxLength={field.maxLength}
            inputMode={field.inputMode}
            autoComplete="off"
            className={`form-control ${showInvalid ? "is-invalid" : ""}`}
            style={field.rtl ? { direction: "rtl" } : {}}
            {...(field.sanitize && typeof setFieldValue === "function"
              ? {
                  onChange: e =>
                    setFieldValue(field.name, field.sanitize(e.target.value)),
                }
              : {})}
          />
          <TextError name={field.name} />
        </div>
      </Col>
    )
  })
}

export default CountryFormDetails
